// combobox.ts

import { $, $inp } from "webgpu-sims";

const aiNames: string[] = [
    "Gemini 3.1 Pro (Standard)", "Gemini 3.1 Pro (Extended)", 
    "Composer 2.5 Fast", "Opus 4.8 High", 
    "GPT-5.6 Sol", "GPT-5.5 Instant", "GPT-5.5 Medium", "GPT-5.5 High", "GPT-5.5 Thinking", 
    "Sonnet 4.6 Medium", "Codex 5.3 Medium"
];

export let aiSelect : EditableSelect;

export class EditableSelect {
    private readonly input: HTMLInputElement;
    constructor(input: HTMLInputElement) {
        this.input = input;

        const dataList = $("ai-options");
        for(const value of aiNames){
            const opt = document.createElement("option");
            opt.value = value;
            dataList.append(opt);
        }
    }

    get value(): string {
        return this.input.value;
    }

    set value(v: string) {
        this.input.value = v;
    }

    onChange(callback: (value: string) => void): void {
        this.input.addEventListener("input", () => {
            callback(this.input.value);
        });
    }
}

export function initComboBox() {
    const input = $inp("ai-inp");

    aiSelect = new EditableSelect(input);

    aiSelect.onChange(value => {
        console.log("Selected:", value);
    });
}
